// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".normal[data-v-40ec4f80]{background:#fff;border-color:#9c9c9c}.active[data-v-40ec4f80]{background:#f1f1ff}.v-menu__content[data-v-40ec4f80]{border-radius:20px;border:7px solid;border-color:#1976d2}", ""]);
// Exports
module.exports = exports;
